module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarOpcoes),
      expression: "mostrarOpcoes"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "quadro_opcoes",
    style: ('min-height: ' + ((_vm.atividades.length * 30) + 20) + 'px;')
  }, [_c('div', {
    staticClass: "zoom"
  }, [_vm._v("Zoom no gantt "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zoom),
      expression: "zoom"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zoom = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm._.range([_vm.start = 1], 3, [_vm.step = .5])), function(z) {
    return _c('option', [_vm._v(_vm._s(z))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "margem"
  }, [_vm._v("Distância das atividades "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tamanho_nome_atividade),
      expression: "tamanho_nome_atividade"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tamanho_nome_atividade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm._.range([_vm.start = 400], 700, [_vm.step = 50])), function(d) {
    return _c('option', [_vm._v(_vm._s(d))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tipo_barra"
  }, [_vm._v("Mostrar execução por "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipo_barra),
      expression: "tipo_barra"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tipo_barra = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "financeiro"
    }
  }, [_vm._v("% do orçado / liberado")]), _c('option', {
    attrs: {
      "value": "declarado"
    }
  }, [_vm._v("% informado no relatório")])])]), _vm._v(" "), _c('div', {
    staticClass: "mostrar_exec_financeira"
  }, [_vm._v("Mostrar Valor Liberado e Orçado "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mostrar_execucao_financeira),
      expression: "mostrar_execucao_financeira"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mostrar_execucao_financeira = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Sim")]), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não")])])]), _vm._v(" "), _c('div', {
    staticClass: "mostrar_exec_declarada"
  }, [_vm._v("Mostrar Percentual Declarado "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mostrar_execucao_declarada),
      expression: "mostrar_execucao_declarada"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mostrar_execucao_declarada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Sim")]), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não")])])]), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large'
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large'}"
    }],
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "title": 'Clique para trazer os dados salvos até o momento'
    },
    on: {
      "click": _vm.carregaAtividades
    }
  }, [_c('i', {
    class: 'fa fa-refresh'
  }), _vm._v(" Atualizar o gráfico")])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-md-12 gantt_atividades"
  }, [_c('div', [_c('div', {
    staticClass: "cabecalho"
  }, [_c('div', {
    staticClass: "linha_marcadoras",
    style: ('height: ' + ((_vm.atividades.length * 30) + 30) + 'px;')
  }, [_c('div', {
    staticClass: "titulo",
    style: ('width: ' + _vm.tamanho_nome_atividade + 'px')
  }, [_vm._v("Atividades")]), _vm._v(" "), _vm._l((_vm.projeto.periodos), function(periodo) {
    return _c('div', {
      staticClass: "periodos_projeto",
      style: ('margin-left: ' + (parseInt(_vm.tamanho_nome_atividade) + ((30 * _vm.zoom) * (periodo - 1))) + 'px;' + 'width: ' + (30 * _vm.zoom) + 'px;')
    }, [_vm._v(_vm._s(periodo) + "\n            ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "hoje",
    style: ('margin-left: ' + (parseInt(_vm.tamanho_nome_atividade) + ((_vm.projeto.hoje_dias < ((_vm.projeto.periodos * 30) + 30) ? _vm.projeto.hoje_dias : ((_vm.projeto.periodos * 30) + 30))) * _vm.zoom) + 'px; height: ' + ((_vm.atividades.length * 30) + 60) + 'px; padding: ' + ((_vm.atividades.length * 30) + 40) + 'px 10px 0px 5px;')
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        theme: 'light'
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', theme: 'light'}"
    }],
    attrs: {
      "title": (_vm.dia_noite === 'DIA' ? 'Bom dia!' : _vm.dia_noite === 'TARDE' ? 'Boa Tarde!' : 'Boa noite!') + '<br/> Já se passaram <b>' + _vm.projeto.hoje_dias + ' dias' + '</b> do início do projeto'
    }
  }, [_c('i', {
    class: _vm.dia_noite === 'DIA' ? 'fa fa-sun-o' : _vm.dia_noite === 'TARDE' ? 'fa fa-sun-o' : 'fa fa-moon-o'
  }), _vm._v(" Hoje")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "atividades",
    style: ('width: ' + ((30 * _vm.projeto.periodos * _vm.zoom) + parseInt(_vm.tamanho_nome_atividade) + 150) + 'px')
  }, _vm._l((_vm.atividades), function(atividade) {
    return _c('div', {
      staticClass: "atividade"
    }, [_c('div', {
      staticClass: "nome_atividade quebrar_texto",
      style: ('width: ' + _vm.tamanho_nome_atividade + 'px')
    }, [_vm._v(_vm._s(atividade.descricao))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'fade',
          distance: '1',
          size: 'large'
        }),
        expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large'}"
      }],
      staticClass: "barra",
      style: ('margin-left: ' + (atividade.dias_inicio * _vm.zoom) + 'px; width: ' + (((atividade.dias_termino - atividade.dias_inicio) * _vm.zoom)) + 'px'),
      attrs: {
        "title": '<h5>' +
          atividade.descricao +
          '<hr>' +
          'Duração: ' + atividade.dias_termino + ' dias<br/>' +
          '% Tempo decorrido: <span class=\'realce\'>' + (_vm.projeto.hoje_dias <= atividade.dias_inicio ? 0 : _vm.projeto.hoje_dias >= atividade.dias_termino ? 100 : ((_vm.projeto.hoje_dias / atividade.dias_termino) * 100) | _vm.percentage) + '%</span>' +
          '<hr>' +
          'Orçado: R$ ' + (parseFloat(atividade.orcado) | _vm.real) + '<br/>' +
          'Liberado: R$ ' + (parseFloat(atividade.executado) | _vm.real) + '<br/>' +
          '% Lib. Financeira: <span class=\'realce\'>' + (_vm.percentualExecutado(atividade.orcado, atividade.executado) | _vm.percentage) + '%</span>' +
          '<hr>' +
          '% Execução da Atividade: <span class=\'realce\'>' + (_vm._.isNil(atividade.execucao) ? '0' : atividade.execucao) + '%' + '</span></h5>'
      }
    }, [_c('div', {
      class: (_vm.tipo_barra === 'declarado' ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado)) >= 0 &&
        (_vm.tipo_barra === 'declarado' ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado)) < 100 ? 'atividade_executada alinha_esquerda sem_tamanho' : (_vm.tipo_barra === 'declarado' ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado)) >= 100 ? 'atividade_completa' : 'atividade_erro alinha_esquerda sem_tamanho',
      style: ('width: ' + (_vm.tipo_barra === 'declarado' ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado)) + '% !important')
    }, [(_vm.mostrar_execucao_financeira && parseFloat(atividade.executado) > 0 && (parseFloat(atividade.executado) < parseFloat(atividade.orcado))) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(parseFloat(atividade.executado))))]) : _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('div', {
      staticClass: "atividade_prevista alinha_esquerda",
      style: ('width: ' + (100 - (_vm.tipo_barra === 'declarado' && !_vm._.isNil(atividade.execucao) ? atividade.execucao : _vm.percentualExecutado(atividade.orcado, atividade.executado))) + '% !important')
    }, [_c('span', [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
      staticClass: "info_adicional"
    }, [(_vm.mostrar_execucao_financeira) ? _c('span', [_vm._v(_vm._s(_vm._f("real")(parseFloat(atividade.orcado))))]) : _vm._e(), _vm._v(" "), (_vm.mostrar_execucao_declarada) ? _c('span', {
      staticClass: "percentual_execucao"
    }, [_vm._v(_vm._s(atividade.execucao) + "%")]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "rodape"
  }, [_c('div', {
    staticClass: "opcoes",
    on: {
      "click": function($event) {
        _vm.mostrarOpcoes = !_vm.mostrarOpcoes
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  }), _vm._v(" Opções\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        interactive: true,
        theme: 'light',
        trigger: 'click'
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'light', trigger: 'click'}"
    }],
    staticClass: "legenda",
    attrs: {
      "title": '<table class=\'legenda_tabela\'>' +
        '<tr><td class=\'atividade_executada\'>&nbsp;</td><td>Total liberado em pagamento, prestação de contas e contrapartidas</td></tr>' +
        '<tr><td class=\'atividade_prevista\'>&nbsp;</td><td> Atividade prevista, valor não liberado </td></tr>' +
        '<tr><td class=\'atividade_completa\'>&nbsp;</td><td> Atividade financeiramente completada </td></tr>' +
        '<tr><td class=\'atividade_erro\'>&nbsp;</td><td> Erro de preenchimento da execução da atividade no relatório </td></tr>' +
        '<tr><td style= \'background: #ca1b1b61\'>&nbsp;</td><td> Data atual no projeto </td></tr>' +
        '</table>'
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Legenda\n          ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c7c08c2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/AtividadesOld.vue
// module id = 1953
// module chunks = 2